/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_ResultInputs */

const en_wb_marketing_result = /** @type {(inputs: Wb_Marketing_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A draft that separates what the data shows from what the team should investigate.`)
};

const lv_wb_marketing_result = /** @type {(inputs: Wb_Marketing_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melnraksts, kas nošķir to, ko rāda dati, no tā, kas komandai jāizpēta.`)
};

/**
* | output |
* | --- |
* | "A draft that separates what the data shows from what the team should investigate." |
*
* @param {Wb_Marketing_ResultInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_result = /** @type {((inputs?: Wb_Marketing_ResultInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_ResultInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_result(inputs)
	return en_wb_marketing_result(inputs)
});